const bad_food = `Aihe: Ongelma ostamieni kananuggettien kanssa
Hyvä myymäläpäällikkö,
Haluan kertoa sinulle jostakin pahasta, mitä tapahtui, kun ostin tänään myymälästäsi kananuggetteja.
Kun keitin niitä illalliseksi, ne eivät tuoksu oikein ja tuntuivat oudolta.
Kun katsoin tarkemmin, jotkut osat eivät vieläkään olleet kypsennettyjä, vaikka noudatin ohjeita.
Tämä sai minut todella surulliseksi ja huolestumaan siitä, että tulen sairaaksi syömättä kypsennettyä ruokaa. 
Sinun tulee myös tarkistaa, miten teet ruoan, jotta tämä ei toistu.
Ole hyvä ja tarkista tämä ja korjaa se, jotta se ei toistu.
Haluaisin rahani takaisin huonoista kananuggeteista.
Sinun tulee myös tarkistaa, miten teet ruoan, jotta tämä ei toistu.
Toivon, että voit tehdä asialle jotain ja saada minut luottamaan jälleen kauppaasi.
Ystävällisin terveisin,`;
export default bad_food;
